import { IAppState } from '@core/state/state.service';
import { AppConfig } from '@core/services/config/app-config.service';

export const selectConfigState = (state: IAppState): AppConfig =>
  state?.config ?? ({} as AppConfig);
